import type { PhotoEffectId } from '@/lib/photo-effects/types/photo-effect-id'
import { clampPhotoEffectValue } from '@/lib/photo-effects/photo-effects-state'

/** Display string for a committed adjustable effect value. */
export function formatPhotoEffectValue(id: PhotoEffectId, value: number): string {
  return String(clampPhotoEffectValue(id, value))
}

/**
 * Parse a numeric field for an adjustable effect.
 * Returns null for empty / non-numeric input — callers revert to last valid on blur.
 */
export function parsePhotoEffectInput(id: PhotoEffectId, raw: string): number | null {
  const trimmed = raw.trim()

  if (trimmed.length === 0) return null

  const parsed = Number(trimmed)

  if (!Number.isFinite(parsed)) return null

  return clampPhotoEffectValue(id, parsed)
}
